import { render, staticRenderFns } from "./GridLoadingOverlay.vue?vue&type=template&id=06bf6e2d&"
import script from "./GridLoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./GridLoadingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./GridLoadingOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports